import { render, staticRenderFns } from "./CommissionRuleList.vue?vue&type=template&id=032a4abe&scoped=true&"
import script from "./CommissionRuleList.vue?vue&type=script&lang=js&"
export * from "./CommissionRuleList.vue?vue&type=script&lang=js&"
import style0 from "./CommissionRuleList.vue?vue&type=style&index=0&id=032a4abe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032a4abe",
  null
  
)

export default component.exports